import { useEffect, useState } from "react";
const isEventInside = (containerRef, e) => containerRef.current?.contains(e.target) ?? false;
function useClickOutside({
  containerRef,
  onClickOutside,
  disable,
  triggerOn
}) {
  const [isPointerDownInside, setIsPointerDownInside] = useState(false);
  useEffect(() => {
    if (disable) {
      return;
    }
    document.addEventListener("pointerdown", handler, true);
    document.addEventListener("pointerup", handler, true);
    return () => {
      document.removeEventListener("pointerdown", handler, true);
      document.removeEventListener("pointerup", handler, true);
    };
  }, [disable, isPointerDownInside, onClickOutside]);
  function handler(e) {
    const isEventInsideContainer = isEventInside(containerRef, e);
    if (e.type === "pointerdown") {
      if (triggerOn === "pointerdown" && !isEventInsideContainer) {
        onClickOutside(e);
        return;
      }
      setIsPointerDownInside(isEventInsideContainer);
      return;
    }
    if (e.type === "pointerup" && !isEventInsideContainer && !isPointerDownInside) {
      onClickOutside(e);
      return;
    }
  }
}
export {
  useClickOutside
};
//# sourceMappingURL=useClickOutside.js.map
